/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RangeInput from '../../../../common/RangeInput/RangeInput'

/**
 * Will return the changed value
 *
 * @param {any} props
 * @returns {number} the value to use
 */
const changeInput = (props) => {
    return (props.value / 2.5)
}

/**
 * Will generate the measurements lines in the layour
 *
 * @param {any} N
 * @returns {ReactDOM}
 */
const generateMeasurements = (N: number) => {
    let array = Array.apply(null, { length: N }).map(Number.call, Number)
    return array.map((item, index) => {
        return (
            <div className={`measurements measurements-commission-${array.length}-${item + 1}`} key={index} />
        )
    })
}

const VariationCommission = (props: any) => {
    const { commissionList = [], maxCommission = '22.5' } = props
    const parsedMaxCommission = parseFloat(maxCommission)

    // Ensure commissionList is explicitly typed as an array of numbers
    const commissionListTyped: number[] = commissionList

    // Find the index of parsedMaxCommission in commissionListTyped
    const index: number = commissionListTyped.indexOf(parsedMaxCommission)
    return (
        <div className="adjustment">
            <div className="adjustment__title">Commission:</div>
            <div className="adjustment__range">
                {generateMeasurements(index !== -1 ? index : 10)}
                <RangeInput
                    onChange={(value) => { props.onChange(value * 2.5) }}
                    value={changeInput(props)}
                    max={index !== -1 ? index : 10}
                    min={0}
                />
            </div>
            <div className="adjustment__result">{props.value}%</div>
        </div>
    )
} // min 0% - 22.5% max

export default VariationCommission



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/VariationCommission.tsx